import { useContext, useEffect } from 'react';
import { useUsers } from '../../hooks/DirectoryHooks';
import { useUserNetwork } from '../../hooks/WPHooks';
import { ModelsService } from '../../services/ModelsService';
import { AppContext } from '../../state/AppContextProvider';
import { DirectoryItem } from '../directory/DirectoryItem';

const UsersResults = ({ items }) => {
  const { state } = useContext(AppContext);

  const { refreshUser } = useUsers(0);

  const { create, update, remove, getUserNetwork, fetch } = useUserNetwork(
    state.user ? state.user.id : null
  );

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-4 min-h-auto">
      {items.map((u, id) => {
        const n = getUserNetwork(state.user?.id || 0, u.id);
        return (
          <DirectoryItem
            key={id}
            backUrl={'/search'}
            userId={u.id}
            name={u.name}
            house={ModelsService.getHouseNameFromTermId(
              ModelsService.getUserHouseRef(u)?.term_id,
              state.allHouses,
              ''
            )}
            avatar={ModelsService.getUserAvatar(u)}
            phone={u.acf.mobilephone || ''}
            email={u.email || ''}
            network={n}
            friendStatus={
              n?.acf?.relation_status ??
              (state.user?.id === u.id ? 'none' : undefined)
            }
            create={create}
            update={update}
            remove={remove}
            refreshUser={refreshUser}
          />
        );
      })}
    </ul>
  );
};

export default UsersResults;
